/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datasets_Create_Table_Placeholder_DescriptionInputs */



/**
* | output |
* | --- |
* | "Optional. What does this table hold? A clear description helps the assistant find it." |
*
* @param {Datasets_Create_Table_Placeholder_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const datasets_create_table_placeholder_description = /** @type {((inputs?: Datasets_Create_Table_Placeholder_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Create_Table_Placeholder_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Optional. Was enthält diese Tabelle? Eine klare Beschreibung hilft dem Assistenten, sie zu finden.")
	return /** @type {LocalizedString} */ ("Optional. What does this table hold? A clear description helps the assistant find it.")
});